<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروها">
      <Loading v-if="loading"></Loading>
      <div v-if="!loading">
        <div v-if="!error">
          <div class="breadcrumb">
            <div class="breadcrumb-item">
              <router-link to="/">صفحه اصلی</router-link>
            </div>
            <div class="breadcrumb-item">
              <router-link to="/cars">خودروها</router-link>
            </div>
            <div class="breadcrumb-item">
              <router-link :to="'/cars/brand/'+carType.brand_id">برند {{ carType.car_brand.title }}</router-link>
            </div>
            <div class="breadcrumb-item">
              <router-link :to="'/cars/model/'+carType.model_id">{{ carType.car_model.title }}</router-link>
            </div>
            <div class="breadcrumb-item">
              {{ carType.title }}
            </div>
          </div>
          <br/>
          <div class="fancy-title-wrapper search-input-area">
            <div class="fancy-title light">
              <h1>
                {{carType.title}}<br/>
                <small>{{carType.english_title}}</small>
              </h1>
            </div>
          </div>
          <br/>

          <ul class="tab-menu">
            <li @click="activateTab('generalTab')" :class="(generalTab?'active':'')">اطلاعات کلی</li>
            <li @click="activateTab('attrTab')" :class="(attrTab?'active':'')">مشخصات فنی</li>
            <li @click="activateTab('technicalTab')" :class="(technicalTab?'active':'')">اطلاعات فنی</li>
          </ul>
          <div class="tab-content-container">
            <div v-if="generalTab" class="tab-content">

              <table class="table table-bordered section-light center">
                <tbody>
                <tr>
                  <th class="center">
                    <div class="">برند</div>
                    <strong>{{ carType.car_brand.title }}</strong>
                  </th>
                  <td class="brand-img">
                    <img :src="carType.car_brand.icon_url" width="50px">
                  </td>
                </tr>
                </tbody>
              </table>

              <button id="show-gallery" class="btn btn-info btn-block">گالری تصاویر</button>
              <br/>

              <div class="car-img">
                <img :src="carType.main_banner_url" class="img-fluid rounded">
              </div>
              <br/>
              <table class="table important-attr table-bordered table-striped section-light center">
                <tbody>
                <tr v-for="(attr,index) in carType.attributes.important" :key="index">
                  <th class="center">{{ attr.name }}</th>
                  <td class="center">
                    <span v-for="(value,index) in attr.value" :key="index">
                    {{ (index > 0 ? ', ' : '') }}{{ value }}
                    </span>
                  </td>
                </tr>
                </tbody>

              </table>

              <br/>
              <div class="bg-white car-content">
                <div class="container">

                  <h2>نقد و بررسی تخصصی&nbsp;{{ carType.title }}</h2>
                  <hr>
                  <p class="p-content" v-html="carType.content"></p>
                </div>
              </div>

            </div>
            <div v-if="attrTab" class="tab-content">

              <h2>مشخصات و اطلاعات فنی&nbsp;"{{ carType.title }}"</h2>

              <div v-for="(group,index) in carType.attributes.all" :key="index">
                <h4>{{ group.name }}</h4>
                <table class="table table-bordered table-striped attr-table pt-4 pb-4 center">
                  <tbody>
                  <tr v-for="(attr,index) in group.values" :key="index">
                    <th class="center">{{ attr.name }}</th>
                    <td class="center">
                    <span v-for="(value,index) in attr.value" :key="index">
                    {{ (index > 0 ? ', ' : '') }}{{ value }}
                    </span>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <br/>
              </div>
            </div>
            <div v-if="technicalTab" class="tab-content">
              <br/>
              <ion-button @click="goToPartsPage" color="success" expand="full">مشاهده اطلاعات فنی قطعات</ion-button>
              <div v-if="carType.car_model && carType.car_model.manual_file.length">
                <ion-button expand="full" :key="index" v-for="(item,index) in carType.car_model.manual_file" @click="openWebpage(item)" color="secondary">دانلود دفترچه راهنما</ion-button>
              </div>
            </div>
          </div>

        </div>
        <div v-if="error" class="ion-padding">
          <br/>
          <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage,IonButton} from '@ionic/vue'
import {mapActions} from "vuex";
import {openWebpage} from '@/shared/helper';
import Loading from "@/components/Loading";

export default {
  name: "types",
  data: function ()
  {
    return {
      generalTab: true,
      attrTab: false,
      technicalTab: false,

      images: [],

      loading: true,
      error: null,
      typeId: null,
      carType: null
    }
  },
  mounted()
  {
    this.typeId = this.$route.params.typeId;
    this.search({id: this.typeId}).then((result) =>
    {
      this.loading = false;
      if (result)
      {
        if (result.carType)
        {
          this.carType = result.carType;
          if (Array.isArray(this.carType.gallery))
          {
            for (let i = 0; i < this.carType.gallery.length; i++)
            {
              this.images.push({
                title: this.carType.title,
                url: this.carType.gallery[i]
              })
            }
          }
        }
        else
          this.error = result.error;
      }
      else
        this.error = 'لطفا از دسترسی تلفن همراه خود به اینترنت مطمئن شوید'
    })
  },
  methods: {
    openWebpage(url)
    {
      openWebpage(url);
    },
    goToPartsPage()
    {
      this.$router.push({path:'/cars/parts/'+this.carType._id,params: {
      otherProp:
      {
        test:'ok'
      }
    }})
    },
    ...mapActions("car", {
      search: 'searchCarType',
    }),
    activateTab(tab)
    {
      if (this[tab])
        return;

      this.generalTab = false;
      this.attrTab = false;
      this.technicalTab = false;
      this[tab] = true;
    },
  },
  components: {
    Loading,
    IonPage,
    IonButton
  }
}
</script>

<style scoped>

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
}

.result-area .table-responsive {
  max-height: 350px;
  overflow-y: auto;
}

.thumbnail img {
  width: 125px;
  height: 125px;
}

.title h4 {
  font-size: 16px;
  height: 45px;
}
.tab-menu{
  position: sticky;
  top: 0;
  box-shadow: 0 4px 9px 0 rgba(0,0,0,0.2);
}
.tab-menu li {
  width: 33%;
}

.brand-img {
  text-align: center;
}

.brand-img img {
  height: 80px;
  max-width: 100%;
  width: auto;
}
.p-content, .p-content * {
  font-size: 18px !important;
  line-height: 30px;
  color: #1f1f1f;
}
h2 {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
h4 {
  font-size: 18px;
  margin-bottom: -10px;
  margin-top: 25px;
}
.table th {
  font-size: 14px;
}
.table td {
  font-size: 16px;
}
</style>